import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4720740c"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=4720740c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Register.vue?vue&type=custom&index=0&blockType=title"
if (typeof block0 === 'function') block0(component)
import block1 from "./Register.vue?vue&type=custom&index=1&blockType=layout"
if (typeof block1 === 'function') block1(component)

export default component.exports